export const EscrowTile = {
    metadata: {
        slotProps: {
            root: {
                sx: {
                    display: 'flex',
                    width: '100%',
                    minHeight: '12.5rem',
                    padding: { xs: '1rem', lg: '2rem' },
                    flexDirection: 'column',
                    alignItems: 'flex-end',
                    gap: '1rem',
                    borderRadius: '2rem',
                    boxShadow: '4px 4px 30px 0px rgba(29, 49, 70, 0.10)',
                    background: '#FEFEFE'
                }
            },
            icon: {
                name: 'Analysis',
                sx: {
                    color: '#00476A',
                    width: '3.125rem',
                    height: '3.125rem'
                }
            },
            heading: {
                variant: 'alt-subtitle1',
                sx: {
                    color: '#12202C'
                }
            },
            content: {
                variant: 'paragraph',
                sx: {
                    color: '#536371',
                    fontFamily: 'Poppins',
                    fontSize: '0.9375rem'
                }
            },
            button: {
                variant: 'text',
                size: 'medium',
                sx: {
                    '&.MuiButton-text': {
                        color: '#00476A',
                        padding: '0.5rem'
                    }
                }
            }
        },
        borderLeftColor: '#9DDCF9',
        borderRightColor: 'rgba(151,151,151,0.36)',
        borderTopColor: 'rgba(151,151,151,0.36)',
        borderBottomColor: 'rgba(151,151,151,0.36)',
        shadow: 10,
        minH: ['235', '220', '220']
    },
    header: {
        icon: 'https://dam.freedommortgage.com/dx/api/dam/v1/collections/7b101923-c80f-4471-a651-acf2e18ecdaa/items/46344b43-e1a0-481a-a5fe-1170d0a1b545/renditions/b9299375-c2a3-4944-b950-f9336eeff098?binary=true',
        title: {
            content: '[header]',
            type: 'text',
            metadata: {
                values: {
                    header: 'Escrow Analysis Ready'
                }
            }
        }
    },
    body: [
        {
            content: '[copy]',
            type: 'text',
            metadata: {
                values: {
                    copy: 'Your escrow analysis is complete. Your payment may be changing. View your analysis to learn more.'
                }
            }
        }
    ],
    callToActions: [
        {
            type: 'cta-deep-link',
            content: '[offerCTA]',
            metadata: {
                deeplink: 'escrow',
                values: {
                    offerCTA: 'View Analysis'
                },
                fontWeight: 'medium'
            },
            event: {
                action: 'EscrowViewAnalysisClicked'
            }
        }
    ]
};
export const Tile1098 = {
    metadata: {
        slotProps: {
            root: {
                sx: {
                    display: 'flex',
                    width: '100%',
                    minHeight: '12.5rem',
                    padding: { xs: '1rem', lg: '2rem' },
                    flexDirection: 'column',
                    alignItems: 'flex-end',
                    gap: '1rem',
                    borderRadius: '2rem',
                    boxShadow: '4px 4px 30px 0px rgba(29, 49, 70, 0.10)',
                    background: '#FEFEFE'
                }
            },
            icon: {
                name: 'DOCReady',
                sx: {
                    color: '#00476A',
                    width: '3.125rem',
                    height: '3.125rem'
                }
            },
            heading: {
                variant: 'alt-subtitle1',
                sx: {
                    color: '#12202C'
                }
            },
            content: {
                variant: 'paragraph',
                sx: {
                    color: '#536371',
                    fontFamily: 'Poppins',
                    fontSize: '0.9375rem'
                }
            },
            button: {
                variant: 'text',
                size: 'medium',
                sx: {
                    '&.MuiButton-text': {
                        color: '#00476A',
                        padding: '0.5rem'
                    }
                }
            }
        },
        borderLeftColor: '#9DDCF9',
        borderRightColor: 'rgba(151,151,151,0.36)',
        borderTopColor: 'rgba(151,151,151,0.36)',
        borderBottomColor: 'rgba(151,151,151,0.36)',
        shadow: 10,
        minH: ['235', '220', '220']
    },
    header: {
        icon: 'https://dam.freedommortgage.com/dx/api/dam/v1/collections/7b101923-c80f-4471-a651-acf2e18ecdaa/items/46344b43-e1a0-481a-a5fe-1170d0a1b545/renditions/b9299375-c2a3-4944-b950-f9336eeff098?binary=true',
        title: {
            content: '[header]',
            type: 'text',
            metadata: {
                values: {
                    header: 'Your 1098 Is Ready!'
                }
            }
        }
    },
    body: [
        {
            content: '[copy]',
            type: 'text',
            metadata: {
                values: {
                    copy: ' 2024 1098 tax forms will be ready by no later than January 31 2025. Click below to view and download your latest 1098. Your 1098 will open in a new tab. Please turn off pop-up blockers to view your file.'
                }
            }
        }
    ],
    callToActions: [
        {
            type: 'cta-deep-link',
            content: '[offerCTA]',
            metadata: {
                deeplink: 'escrow',
                values: {
                    offerCTA: 'View Latest 1098'
                },
                fontWeight: 'medium'
            },
            event: {
                action: 'ViewLatest1098Clicked'
            }
        }
    ]
};
export const Paperless = {
    metadata: {
        slotProps: {
            root: {
                sx: {
                    display: 'flex',
                    width: '100%',
                    minHeight: '12.5rem',
                    padding: { xs: '1rem', lg: '2rem' },
                    flexDirection: 'column',
                    alignItems: 'flex-end',
                    gap: '1rem',
                    borderRadius: '2rem',
                    boxShadow: '4px 4px 30px 0px rgba(29, 49, 70, 0.10)',
                    background: '#FEFEFE'
                }
            },
            icon: {
                name: 'Paperless',
                sx: {
                    color: '#00476A',
                    width: '3.125rem',
                    height: '3.125rem'
                }
            },
            heading: {
                variant: 'alt-subtitle1',
                sx: {
                    color: '#12202C'
                }
            },
            content: {
                variant: 'paragraph',
                sx: {
                    color: '#536371',
                    fontFamily: 'Poppins',
                    fontSize: '0.9375rem'
                }
            },
            button: {
                variant: 'text',
                size: 'medium',
                sx: {
                    '&.MuiButton-text': {
                        color: '#00476A',
                        padding: '0.5rem'
                    }
                }
            }
        },
        borderLeftColor: '#9DDCF9',
        borderRightColor: 'rgba(151,151,151,0.36)',
        borderTopColor: 'rgba(151,151,151,0.36)',
        borderBottomColor: 'rgba(151,151,151,0.36)',
        shadow: 10,
        minH: ['235', '220', '220']
    },
    header: {
        icon: 'https://dam.freedommortgage.com/dx/api/dam/v1/collections/7b101923-c80f-4471-a651-acf2e18ecdaa/items/46344b43-e1a0-481a-a5fe-1170d0a1b545/renditions/b9299375-c2a3-4944-b950-f9336eeff098?binary=true',
        title: {
            content: '[header]',
            type: 'text',
            metadata: {
                values: {
                    header: 'Go Paperless'
                }
            }
        }
    },
    body: [
        {
            content: '[copy]',
            type: 'text',
            metadata: {
                values: {
                    copy: 'Enjoy the convenience of e-documents. View your billing statement, payment confirmation notices, and more.'
                }
            }
        }
    ],
    callToActions: [
        {
            type: 'cta-deep-link',
            content: '[offerCTA]',
            metadata: {
                deeplink: 'escrow',
                values: {
                    offerCTA: 'Sign Up'
                },
                fontWeight: 'medium'
            },
            event: {
                action: 'PaperlessSignUpClicked'
            }
        }
    ]
};
